<template>
    <div class="manager col-sm-6 col-xs-12">
        <b-card show-header class="mb-4" show-footer>
            <h3 slot="header">{{ manager.name | translate }}</h3>
            <div class="row">
                <div class="col-xs-12 col-md-4">
                    <div class="icon btn">
                        <img :src="'/img/managers/' + manager.icon" alt="">
                    </div>
                </div>
                <div class="col-xs-12 col-md-8">
                    <span>{{ manager.description | translate }}</span>
                    <span>{{ $t('MANAGE_TEXT', {shopType: $t(manager.shop)}) }}</span>
                </div>
            </div>
            <div slot="footer">
                <button v-if="!manager.isHired"
                        :id="'hire.manager-' + manager.id"
                        class="btn btn-primary"
                        :class="{'disabled': manager.costs.gt(balance)}"
                        @click="hire(manager)">
                    <span class="buy-text">
                        {{ $t('HIRE_FOR', {costs: tl(manager.costs)}) }}
                    </span>
                </button>
                <button v-else class="btn btn-default disabled">
                    <i class="fa fa-check-circle"></i> <span class="applied-text">{{ 'MANAGER_ALREADY_HIRED' | translate }}</span>
                </button>
                <b-popover show :title="step.title" :target="'hire.manager-' + manager.id" v-if="manager.id === 'manager-0' && step.id === 9">
                    {{ step.text }}
                </b-popover>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NiceAmount from '../filters/NiceAmount';
export default {
    name:     'manager',
    props:    ['manager'],
    computed: mapGetters({
        balance: 'totalBalance',
        step:    'step'
    }),
    methods:  {
        ...mapActions([
            'incrementAmount',
            'setStep'
        ]),
        hire(manager) {
            this.$store.commit('HIRE_MANAGER', { manager });
        },
        tl(val) {
            return NiceAmount(val);
        }
    }
};
</script>

<style scoped lang="less">
.panel .icon i {
    display: flex;
    justify-content: center;
    align-items: center;
}
.icon img {
    max-width: 100%;
    max-height: 6.6vw;
    max-height: 100%;
}
</style>
